import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { CountryDto } from 'src/app/domain/models/dto/country.dto';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  constructor(private readonly http: HttpClient) { }

  get() {
    return this.http.get<ResponseObjectModel<CountryDto[]>>(`${environment.API_BASE_URL}/v1/country`)
      .pipe(
        map(response => {
          if (response.data) {
            response.data.sort((a, b) =>
              (a.description || '').localeCompare(b.description || '', 'pt-BR')
            );
          }
          return response;
        })
      );
  }

}
